<template>
    <option-with-text-input
        :checkbox-checked="watermarkPrefixCheckbox"
        checkbox-id="watermark_wire_file_number_prefix_checkbox"
        input-name="watermark_wire_file_number_prefix"
        :input-value="watermarkPrefixInput"
        :is-admin
        :max-length="25"
    >
        <template #label>Set custom prefix to </template>
        <template #tooltip>
            <span>
                <FontAwesomeIcon
                    aria-hidden="true"
                    class="fas fa-info-circle help-bubble"
                    title="Default is: 'File #''"
                />
            </span>
        </template>
    </option-with-text-input>
</template>

<script setup lang="ts">
import OptionWithTextInput from '@/components/Views/Company/Settings/OptionWithTextInput.vue';

const props = defineProps<{
    isAdmin: boolean;
    watermarkOnWireInstructions: {
        watermarkPrefixCheckbox: boolean;
        watermarkPrefixInput: string;
    };
}>();

const { watermarkPrefixCheckbox, watermarkPrefixInput } = props.watermarkOnWireInstructions;
</script>
